import 'whatwg-fetch';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';

import VueMeta from 'vue-meta';
import { addCdnStyles, addMeta, addStylePage, addExternalJsFiles, addHeaderStyles, addFooterStyles } from './add_extend_scripts'
import getAll from './API/getAll.js';
import {_getUrlParams, writeProductsToStorage} from "@/functions/base";
import VueI18n from 'vue-i18n';

import store from '@/store/index.js';
import defaultMessages from './dictionary/default/index.js';

Vue.use(VueClipboard);
Vue.use(VueMeta);

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import checkHostOnDev from "./helpers/checkHostOnDev";

const APP_SELECTOR = '#app';
const HEADER_SELECTOR = '#compare-header';
const RR_SELECTOR = '#rr-container';
const FOOTER_SELECTOR = '#compare-footer';

if (process.env.NODE_ENV === 'production' && !checkHostOnDev()) {
  Sentry.init({
    Vue,
    dsn: "https://43ef0570b58f4a09b76c26a1da09081a@o210643.ingest.sentry.io/5753593",
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0
  });
}


Vue.use(VueI18n);
addFooterStyles()
addHeaderStyles()
addMeta()
addCdnStyles()
addExternalJsFiles()

function setTranslateLanguage() {
  const url = window.location.origin;
  const sitesWithNlLanguage = ['ikwordmama', 'horecahome'];
  return sitesWithNlLanguage.some(site => url.indexOf(site) !== -1) ? 'nl_NL' : 'ru_RU';
}

addStylePage().onload = () => {
  const url = new URL(window.location.href);
  const { ids, base64 } = _getUrlParams(url);
  const response = async () => await getAll(ids, base64)
  response().then(data => {
    if(data.success){
      const root = () =>  import(`./layout/${data.store_template_name}/${data.store_template_theme}/App.vue`).catch(() => {
        return import('./layout/default/App.vue')
      })
      writeProductsToStorage(data.categories)

      const messages =  () => import(`./dictionary/${data.store_template_name}/index.js`).catch(() => {
        return import('./dictionary/default/index.js')
      })
      messages().then(response => {
        setTimeout(() => {
          $(document).trigger('aristos:compare:get-config', data)
        }, 1000)
        const header = document.querySelector(HEADER_SELECTOR);
        const rrContainer = document.querySelector(RR_SELECTOR);
        const footer = document.querySelector(FOOTER_SELECTOR);

        if (header) {
          header.innerHTML = data.header;
        }

        if (rrContainer && Array.isArray(data.retail_rocket?.rr_blocks)) {
          data.retail_rocket.rr_blocks.forEach((block) => {
            if (typeof block === 'string') {
              rrContainer.insertAdjacentHTML('beforeend', block);
            }
          });
        }

        if (footer) {
          footer.innerHTML = data.footer;
        }

        const renderRoot = new Vue({
          el: '#app',
          store,
          i18n: new VueI18n({
            locale: setTranslateLanguage(),
            messages: response.default
          }),
          data: function (){
            return {
              template: data.store_template_name,
              theme: data.store_template_theme,
              categoriesDefault: data.categories,
              groupsDefault: data.groups,
              retailRocketId: data.retail_rocket ? data.retail_rocket.id : null,
              productIds: data.retail_rocket ? data.retail_rocket.product_ids : '',
              userStatus: data.retail_rocket ? data.retail_rocket.user_status : '',
              retailRocketIdEmptyCompare: data.retail_rocket?.id_empty_compare
            }
          },
          render: h => h(root),
        })
      })
    }
  }).catch(e => {
    console.error(e)
    const additionalElements = document.querySelectorAll(`${HEADER_SELECTOR}, ${FOOTER_SELECTOR}`);
    if (additionalElements.length) {
      additionalElements.forEach(el => el.remove());
    }
    const root = () => import(`./layout/default/components/ErrorInfo.vue`);

    new Vue({
      el: APP_SELECTOR,
      i18n: new VueI18n({
        locale: setTranslateLanguage(),
        messages: defaultMessages
      }),
      render: h => h(root),
    })
  })
}

